import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import {
    gruposMateriaisModuleName, grupoMaterialCodigoMask, subgruposMateriaisRouter,
    gruposMateriaisStorage
} from "../shared/data.service";
import {GrupoMaterialService} from "../shared/grupo-material.service";
import {GrupoMaterialApiService} from "../shared/grupo-material-api.service";
import {GrupoMaterialNavigationService} from "../shared/grupo-material-navigation.service";
import {ContaContabilApiService} from "../../../contas/conta-contabil/shared/conta-contabil-api.service";
import {ContaContabilNavigationService} from "../../../contas/conta-contabil/shared/conta-contabil-navigation.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {UtilService} from "../../../shared/services/util.service";
import {GrupoMaterialCodigoValidator} from "../shared/validators/grupo-material-codigo.validator";
import {contasContabeisStorage, contasContabeisQuery} from "../../../contas/conta-contabil/shared/data.service";
import {ContaContabilService} from "../../../contas/conta-contabil/shared/conta-contabil.service";
import {newRoute, editRoute} from "../../../shared/services/data.service";
import {ContaContabil} from "../../../contas/conta-contabil/shared/conta-contabil.model";

@Component({
    selector: 'grupo-material-formulario',
    template: require('./grupo-material-form.component.html')
})

export class GrupoMaterialFormComponent implements OnInit {
    grupoMaterialModule: string = gruposMateriaisModuleName;
    formObject: any = {};
    grupoObject: any = {};
    contaContabilObject: ContaContabil = new ContaContabil();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;

    btnSalveDisabled: boolean = false;
    submitAttempt: boolean = false;
    isMaterialSubgrupo: boolean = false;
    codeExists: boolean = false;
    codigoMask: number = grupoMaterialCodigoMask;
    gruposList: Array<any> = [];

    form: FormGroup;
    codigo = new FormControl('', Validators.compose([Validators.required, GrupoMaterialCodigoValidator.grupoMaterialCodigoFormat]));
    descricao = new FormControl('', Validators.required);
    contaContabil = new FormControl();
    grupo = new FormControl();
    ativo = new FormControl();

    contaContabilQuery: any;
    contaContabilSelectId: string = 'grupoMaterial_contacontabil';

    private materialSubgrupRouter: string = subgruposMateriaisRouter;
    private hasSession:boolean = false;
    private contaContabilTipo: number;
    private oldCodeEdit: number;
    private oldGrupoEdit: number;
    private returnToOtherForm: boolean = false;
    private otherForm: string = "";
    private responseGrupoMaterial: any;

    constructor(
        private _grupoMaterialService: GrupoMaterialService,
        private _grupoMaterialApiService: GrupoMaterialApiService,
        private _grupoMaterialNavigationService: GrupoMaterialNavigationService,
        private _contaContabilApiService: ContaContabilApiService,
        private _contaContabilNavigationService: ContaContabilNavigationService,
        private _contaContabilService: ContaContabilService,
        private _autocompleteService: AutoCompleteService,
        private _utilService: UtilService,
        private _router: Router,
        private _route: ActivatedRoute,

        private builder: FormBuilder
    ){
        this.form = builder.group({
            ativo: this.ativo,
            grupo : this.grupo,
            codigo: this.codigo,
            descricao: this.descricao,
            contaContabil : this.contaContabil
        });
    }

    ngOnInit() {
        this.contaContabilQuery = this._utilService.cloneObject(contasContabeisQuery);
        this.contaContabilTipo = this._contaContabilService.getTipoEstoque();

        var parentRouter: any = this._router.url;
        var parentLocation = parentRouter.indexOf(this.materialSubgrupRouter);
        if (parentLocation !== -1) {
            this.isMaterialSubgrupo = true;
            this.contaContabilQuery.where.tipoId = this.contaContabilTipo;
        }

        this.isNewAutoComplete();
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    onSubmit(evt: any) {
        this.submitAttempt = true;

        if (this.grupoObject) {
            if (this.grupoObject.id && !this.contaContabilObject.id) {
                return false;
            }
        }

        if(evt.valid && !this.codeExists) {
            this.btnSalveDisabled = true;
            var object:any = this._utilService.cloneObject(this.formObject);

            if (this.grupoObject) {
                if (this.grupoObject.id) {
                    object.grupoId = this.grupoObject.id;
                    object.codigoGrupo = object.codigo;
                    object.codigo = null;

                    if (this.contaContabilObject.id) {
                        object.contaContabilId = this.contaContabilObject.id;
                    } else {
                        object.contaContabilId = null;
                    }
                }
            }

            if (object.id) {
                this.onEditGrupoMaterial(object);
            } else {
                this.onSaveGrupoMaterial(object);
            }
        }
    }

    blurCode() {
        var code: string = this.formObject.codigo;
        if (this.formObject.codigo != this.oldCodeEdit) {
            if (this.isMaterialSubgrupo) {
                this.checkIfExistsCodeSubgrupo(code, this.grupoObject.id);
            } else {
                this.checkIfExistsCodeGrupo(code);
            }
        }
    }

    changeGrupo() {
        if (this.grupoObject.id) {
            if (this.grupoObject.id !== this.oldGrupoEdit) {
                this.onGetFather(this.grupoObject.id);
            } else {
                this.formObject.codigo = this.oldCodeEdit;
            }
        }
    }

    //conta contabil
    onGetContaContabilObject(object: any) {
        if(object.novo) {
            var thisFormObject:any = this.setObjectBeforeLeave();
            this._grupoMaterialService.setSessionStorage(thisFormObject);

            var objectModel: any = {
                descricao: object.text,
                tipoId: this.contaContabilTipo,
                descricaoAnalitica: true,
                novo: true,
                form: gruposMateriaisStorage
            };
            this._autocompleteService.setSessionStorage(objectModel, contasContabeisStorage);
            this._contaContabilNavigationService.goToNew();
        } else {
            this.contaContabilObject = object;
            if (object.id) {
                this._utilService.setSelectOnFormControl(this.form, 'contaContabil', object);
            } else {
                this._utilService.setSelectOnFormControl(this.form, 'contaContabil', {id: -1});
            }
        }
    }

    //grupos - relacao
    onGetGrupos(grupoId: any) {
        var onDone = (function (Response: any) {
            if (!Response.error) {
                this.gruposList = Response;

                var x: any, lenX: any;
                for (x = 0, lenX = this.gruposList.length; x < lenX; x++) {
                    if (this.gruposList[x].id === grupoId) {
                        this.grupoObject = this.gruposList[x];
                        break;
                    }
                }
            }
        }.bind(this));

        this._grupoMaterialApiService.onGetGrupos(onDone);
    }

    contaContabilTemplateResult = (function(state: any) {
        var template: any = this._contaContabilService.templateResult(state, true);
        return template;
    }.bind(this));

    private onSaveGrupoMaterial(objeto: any) {
        this._grupoMaterialApiService.onPost(objeto, this.onDone);
    }

    private onEditGrupoMaterial(objeto: any) {
        this._grupoMaterialApiService.onPut(objeto, this.onDone);
    }

    private onDone = (function(Response: any) {
        if (!Response.error)  {
            var contaContabil: any = this.contaContabilObject;
            Response.contaContabil = contaContabil;
            this.responseGrupoMaterial = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private setObjectBeforeLeave() {
        var object:any = this.formObject;
        object.contaContabil = this.contaContabilObject;
        object.grupo = this.grupoObject;
        object.grupoId = this.grupoObject.id;
        object.codigoGrupo = this.formObject.codigo;

        return object;
    }

    private onGetFather(fatherId: number) {
        var onDone = (function(Response: any) {
            if (!Response.error) {
                var nextCode: string;

                if (this.isMaterialSubgrupo) {
                    nextCode = Response.codigoGrupo.toString();
                } else {
                    nextCode = Response.codigo.toString();
                }

                var newCode: any = this._grupoMaterialService.getLastCodeNumber(nextCode);

                this.formObject.codigo = newCode;
            }
            this.loading = false;
        }.bind(this));

        this._grupoMaterialApiService.onGetFather(fatherId, onDone);
    }

    private checkIfExistsCodeSubgrupo(newCode: string, fatherId: number) {
        //newCode = newCode.replace(/0/g, '');
        this._grupoMaterialApiService.onGetByCodeSubgrupo(newCode, fatherId, this.onDoneExists);
    }

    private checkIfExistsCodeGrupo(newCode: string) {
        //newCode = newCode.replace(/0/g, '');
        this._grupoMaterialApiService.onGetByCodeGrupo(newCode, this.onDoneExists);
    }

    private onDoneExists = (function(Response: any) {
        if (!Response.error) {
            if (Response.length > 0) {
                this.codeExists = true;
            } else {
                this.codeExists = false;
            }
        } else {
            console.log("Erro: " + Response.message);
        }
        this.loading = false;
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum grupo de material encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._grupoMaterialApiService.onGetById(id, onDone);
    }

    private testSession() {
        var id: number;
        var session: any = this._grupoMaterialService.getSessionStorage();
        this._grupoMaterialService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        //se tiver alguma configuração inicial de um cadastro novo
        if (this.isMaterialSubgrupo) {
            let id = +this._route.snapshot.params['grupoId'];

            this.contaContabilObject = new ContaContabil();
            this.onGetFather(id);
            this.onGetGrupos(id);
        } else {
            this.onGetFather(0);
        }
    }

    private setEditSession() {
        //qndo retornou para continuar a edição
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(gruposMateriaisStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.descricao = newAutoComplete.descricao;
            this.grupoObject = newAutoComplete.grupo;

            if (this.grupoObject) {
                this.onGetFather(this.grupoObject.id);
            } else {
                this.onGetFather(0);
            }

            this.setActionTitle(this.formObject.id);
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private setModelToForm() {
        if (this.isMaterialSubgrupo) {
            this.formObject.codigo = this.formObject.codigoGrupo;
            // this.onGetFather(this.formObject.grupoId);
            this.onGetGrupos(this.formObject.grupoId);
        }

        this.formObject.codigo = this._grupoMaterialService.getLastCodeNumber(this.formObject.codigo.toString());
        this.oldCodeEdit = this.formObject.codigo;
        this.oldGrupoEdit = this.formObject.grupoId;

        if (this.formObject.contaContabil) {
            this.contaContabilObject = this.formObject.contaContabil;
            delete this.formObject['contaContabil'];

            var text: string = this._autocompleteService.getTextSelect2(this.contaContabilObject, 'descricao');
            if (this.contaContabilObject.codigo) {
                text = this.contaContabilObject.codigo.concat(" - " + text);
            }
            var selectObject:any = {text: text, id: this.contaContabilObject.id};

            if (this.contaContabilObject.id) {
                setTimeout(function() {
                    this._autocompleteService.createOptionOnSelect2(this.contaContabilSelectId, selectObject);
                    this._autocompleteService.setValueOnSelect2(selectObject.id, this.contaContabilSelectId);
                }.bind(this));
                this._utilService.setSelectOnFormControl(this.form, 'contaContabil', this.contaContabilObject);
            }
        }
    }

    private goToList() {
        this._grupoMaterialNavigationService.goToList();
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._grupoMaterialService.returnToOtherForm(this.otherForm, this.responseGrupoMaterial);
        } else {
            this.goToList();
        }
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/grupos-materiais/grupo-material-form/grupo-material-form.component.ts
 **/